<template>
	<popup v-model="show" height="100%" :isShowMask="false">
		<div class="v5-checklist-content">
			<div class="v5-checklist-header" :style="{paddingTop: paddingTop+'px'}">
				<div class="v5-checklist-header-content" :style="{paddingTop: paddingTop+'px'}">
					<a href="javascript:;" class="v5-checklist-close" @click="close"></a>
					{{title}}
				</div>
			</div>
			<slot name="extend"></slot>
			<div class="v5-checklist-main" :class="{'v5-checklist-main-wrap':isShowFooter}">
				<div class="v5-checklist-content-wrap" v-for="(item,index) in currentData" :key="index">
					<x-checklist :options="item" v-model="currentValue[index]" :preIndexing="indexing" :max="max" class="v5-checklist-content" @on-limit="limit"
					 v-if="level === 1 || index === level-1 ">
						<span class="v5-checklist-content-item" slot-scope="{ props }">
							{{props.name}}
						</span>
					</x-checklist>
					<x-radiolist :options="item" v-model="currentValue[index]" class="v5-checklist-content" v-else>
						<span class="v5-checklist-content-item" slot-scope="{ props }">
							{{props.name}}
						</span>
					</x-radiolist>
				</div>
			</div>
			<selected v-model="isShowFooter" :selects="currentValue[level-1]" :max="max" @update="updateValue" @confirm="confirm"></selected>
			<toast v-model="isShowToast">最多只能选择{{max}}个</toast>
		</div>
	</popup>
</template>
<script>
	import Popup from './../popup';
	import XChecklist from './../x-checklist';
	import XRadiolist from './../x-radiolist';
	import Toast from './../toast';
	import Selected from './selected';
	export default {
		name: 'v5-checklist',
		props: {
			value: {
				type: Boolean,
				default: false
			},
			title: {
				type: String,
				default: '请选择'
			},
			max: {
				type: Number,
				default: 5
			},
			selects: {
				type: Array,
				default: () => []
			},
			data: {
				type: Array
			},
			paddingTop: {
				type: Number
			}
		},
		components: {
			Popup,
			XChecklist,
			XRadiolist,
			Toast,
			Selected
		},
		computed: {
			isShowFooter() {
				return this.currentSelected.length > 0;
			}
		},
		watch: {
			selects(val) {
				this.updateValue(val);
			},
			value(val) {
				this.show = val;
			},
			currentValue(val) {
				if (val.length === this.level) {
					this.setSelValue(val[this.level - 1]);
					this.$emit('on-change', this.currentSelected);
				}
				//选中数据变化时，联动更新列表数据
				this.updateData();
			}
		},
		methods: {
			//关闭
			close() {
				//如果点击右上角的关闭，则不保存当前选择的数据，重置为初始化的数据
				if (this.currentValue.length === this.level) {
					this.updateValue(this.selects);
				}
				this.$emit('on-close');
			},
			//确认
			confirm() {
				this.$emit('on-confirm', this.currentSelected);
			},
			//达到限制
			limit(val) {
				this.isShowToast = true;
			},
			//更新选择数据
			updateValue(val) {
				this.currentValue.pop();
				this.currentValue.push(val);
			},
			//设置当前选择的数据
			setSelValue(val) {
				this.currentSelected = val;
			},
			//初始化选中数据
			initCurrentValue() {
				let currentId = this.selects[0] && this.selects[0]['id']; //当前列表选中项的ID（如果当前列表有多个选中项则取第一个的ID）
				let selectIds = this.selects.map(p=>p.id);
				let hitArray  = [];

				//因为列表数据是根据选中数据联动的，即currentData数组长度等于currentValue
				//所以无默认选中项时，初始化需要push一个空值

				if (this.selects.length === 0 && this.level > 1) {
					this.currentValue.push({});
					return;
				}
				this.currentValue.push(this.selects);

				//根据最后一级选中项的值反向生成前面的选中项
				for (let index = this.level - 1; index > 0; index--) {
					this.data[index].forEach(item => {
						let hitFlag = false;
						let currentIndex = item.list.findIndex(secondItem => {
							if(selectIds.includes(secondItem.id)) hitFlag = true;
							return secondItem.id === currentId;
						});
						if(hitFlag){
							hitArray = hitArray.concat(item.list);
						}
						if (currentIndex !== -1) {
							currentId = item['parentId'];
							this.currentValue.unshift({
								id: currentId
							});
							return;
						}
					});
				}

				let self = this;
				hitArray.forEach( function(ele, index) {
					self.indexing[ele.id] = {
						id: ele.id,
						name: ele.name,
						checked: false
					}
				});

			},
			//更新列表数据
			updateData() {
				let currentId;
				for (let index = 0; index < this.level; index++) {
					//首列数据不做更新
					if (index === 0 && this.currentData[index]) {
						continue;
					}
					//初始化首列数据
					if (index === 0 && this.currentData[index] === undefined) {
						this.currentData.push(this.data[0]);
						continue;
					}

					//初始化或更新非首列数据
					currentId = this.currentValue[index - 1]['id'];
					if (!currentId) {
						return;
					}
					let temp = Array.prototype.find.call(this.data[index], item => {
						return item['parentId'] === currentId;
					});
					this.currentData[index] = temp['list'];
				}
			}
		},
		data() {
			return {
				level: this.data.length, //选择列表层级
				indexing: {},
				currentSelected: [], //追踪返回的选中数据
				currentData: [], //当前列表数据
				currentValue: [], //当前所有选中数据
				show: this.value, //是否展示弹窗
				isShowToast: false //是否展示提示
			};
		},
		created() {
			this.initCurrentValue();
		}
	};

</script>
<style lang='scss'>
	@import './style.scss';

</style>
